import React from "react";
import { Box, Flex, Text, useColorModeValue as mode } from "@chakra-ui/react";

const ScheduledMessageRow = ({
  id,
  text,
  toNumber,
  fromNumber,
  customerName,
  createdOn,
  scheduledFor,
  index,
  header,
  selected,
  onSelect,
}) => {
  return (
    <Flex
      bg={
        selected
          ? mode("blue.100", "blue.700")
          : index % 2 === 0
          ? mode("white", "gray.800")
          : mode("gray.100", "gray.700")
      }
      align='center'
      justify='start'
      borderBottom='1px solid'
      borderColor={mode("gray.200", "gray.600")}
      //alignItems='stretch'
      onClick={() => {
        if (onSelect) onSelect(index);
      }}
      // onDoubleClick={() => {
      //   if (onDouble) onDouble(index);
      // }}
      cursor='pointer'
      width='100%'
      minH='40px'
      fontSize='sm'
    >
      <Box
        flex='1'
        borderRight='1px solid'
        borderColor={mode("gray.200", "gray.600")}
        pl='2'
        // onClick={() => {
        //   if (onDouble) onDouble(index);
        // }}
      >
        <Text
          textAlign='left'
          fontWeight={header ? "bold" : "normal"}
          //p={2}
          //textDecoration={header ? "none" : "underline"}
          //textUnderlineOffset='2px'
          p='1'
        >
          {header ? "#" : index + 1}
        </Text>
      </Box>
      <Box flex='3' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {createdOn}
        </Text>
      </Box>
      <Box flex='3' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {scheduledFor}
        </Text>
      </Box>
      <Box flex='2' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text flex='2' fontWeight={header ? "bold" : "normal"} p={1}>
          {toNumber}
        </Text>
      </Box>
      <Box flex='2' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text flex='2' fontWeight={header ? "bold" : "normal"} p={1}>
          {fromNumber}
        </Text>
      </Box>
      <Box flex='4' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text flex='2' fontWeight={header ? "bold" : "normal"} p={1}>
          {customerName}
        </Text>
      </Box>
      <Box flex='6' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text
          flex='2'
          noOfLines={selected ? undefined : 1}
          textAlign='left'
          fontWeight={header ? "bold" : "normal"}
          p={1}
          overflow={"hidden"}
        >
          {text}
        </Text>
      </Box>
    </Flex>
  );
};

export default ScheduledMessageRow;
